export const defaultLimit = 10;

export const calculateOffsetFromPageAndLimit = (page, limit) => {
  return (page - 1) * limit;
};
